import PropTypes from 'prop-types';

import { Check as CheckIcon } from '@common/components/Icons';

import {
  Checkbox,
  MockedCheckbox,
  FilterRow,
  ItemsCount,
  SizeTitle,
} from './FilterRow.styled';

export function SizeFilterRow({
  title,
  value,
  selected,
  onClick,
  onSelect,
  itemsCount,
}) {
  const handleClick = e => {
    if (itemsCount > 0) {
      if (onClick) {
        onClick(e);
      }

      onSelect(value);
    }
  };

  return (
    <FilterRow
      htmlFor={title}
      disabled={itemsCount === 0}
    >
      <Checkbox
        id={title}
        checked={selected}
        disabled={itemsCount === 0}
        onChange={handleClick}
      />
      <SizeTitle isDisabled={itemsCount === 0}>{title}</SizeTitle>
      <ItemsCount>{itemsCount}</ItemsCount>
      <MockedCheckbox
        disabled={itemsCount === 0}
        selected={selected}
      >
        <CheckIcon />
      </MockedCheckbox>
    </FilterRow>
  );
}

SizeFilterRow.defaultProps = {
  itemsCount: undefined,
  onClick: undefined,
  selected: false,
};

SizeFilterRow.propTypes = {
  itemsCount: PropTypes.number,
  onClick: PropTypes.func,
  onSelect: PropTypes.func.isRequired,
  selected: PropTypes.bool,
  title: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};
